<template>
    <div :class="[modalClasses, 'z-40 cursor-pointer md:p-6']">
        <button
            type="button"
            @click="toggleModal"
            class="bg-white md:rounded-md p-2 inline-flex items-center justify-center z-50 text-black hover:text-black hover:bg-gray-100 md:text-gray-400 md:hover:text-gray-500 md:hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-black-900 absolute md:top-4 md:right-4 top-0 right-0">
            <span class="sr-only">Close menu</span>
            <!-- Heroicon name: outline/x -->
            <svg
                class="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true">
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12" />
            </svg>
        </button>
        <div
            :class="[
                { modalVisible: isModalOpen },
                'fixed flex cursor-auto items-center justify-center z-40 max-w-[900px] h-screen md:h-auto w-screen hidden screen border-box',
            ]"
            style="max-height: calc(100vh - 24px)">
            <div
                class="bg-white rounded-lg md:p-6 p-4 md:h-auto h-full overflow-auto md:max-w-[900px] md:mx-auto">
                <slot name="body"></slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { useModalStore } from '@/stores/modals';
    import { computed } from 'vue';

    const modalStore = useModalStore();

    // Create a computed property that tracks the 'open' state from the store
    const isModalOpen = computed(() => modalStore.state.open);

    const toggleModal = () => {
        // Update the 'open' property in the store when needed
        modalStore.updateModal('open', false);
    };

    const modalClasses = computed(() => {
        return [isModalOpen.value ? 'bgModal' : 'bgModal hidden'];
    });

    const closeModalOnEscape = (event) => {
        if (event.key === 'Escape') {
            toggleModal();
        }
    };
    // Attach and detach escape key listener based on the modal's open state
    watch(isModalOpen, (newValue) => {
        if (newValue) {
            window.addEventListener('keydown', closeModalOnEscape);
        } else {
            window.removeEventListener('keydown', closeModalOnEscape);
        }
    });

    // Ensure to remove the event listener when the component is unmounted
    onUnmounted(() => {
        window.removeEventListener('keydown', closeModalOnEscape);
    });
</script>

<style scoped lang="scss">
    .modalVisible {
        display: flex !important;

        flex-direction: column;
        align-items: flex-start;
        gap: 24px;

        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        border-radius: 8px;
        max-width: calc(100% - 36px);

        @media only screen and (max-width: 767px) {
            height: 100vh !important;
            border-radius: 0px !important;
            max-height: none !important;
            max-width: 100%;
            transform: none;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;

            .bg-white {
                border-radius: 0px !important;
                padding: 42px;
                padding-right: 48px;
                padding-top: 84px;
                padding-bottom: 84px;
            }
        }
    }

    .bgModal {
        height: 100%;
        width: 100%;
        position: fixed;
        background: 70% #121212b2;
        top: 0;
        left: 0;
        @media only screen and (max-width: 767px) {
            height: 100vh !important;
            border-radius: 0px !important;
            max-height: none !important;
        }
    }
</style>
